import { MicrosoftService } from '@api';

import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createAlfredMicrosoftConnectionEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackConnectionAppConnect = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ALFRED_CONNECT_OPEN,
      properties: { source },
    });

  const trackMicrosoftServiceConnected = (
    subtype: MicrosoftService,
    source: PosthogTrackingSource
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SERVICE_CONNECTED,
      properties: { type: 'microsoft', subtype, source },
    });

  const trackMicrosoftServiceDisconnected = (
    subtype: MicrosoftService,
    source: PosthogTrackingSource
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SERVICE_DISCONNECTED,
      properties: { type: 'microsoft', subtype, source },
    });

  const trackMicrosoftServiceConnectionError = (
    subtype: MicrosoftService,
    source: PosthogTrackingSource,
    error?: unknown
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SERVICE_CONNECTION_ERROR,
      properties: {
        type: 'microsoft',
        subtype,
        source,
        error: error instanceof Error ? error.message : String(error),
      },
    });

  return {
    trackConnectionAppConnect,
    trackMicrosoftServiceConnected,
    trackMicrosoftServiceDisconnected,
    trackMicrosoftServiceConnectionError,
  };
};
